<template>
  <div><div class="row">
    <div class="col-md-12 pa10">
      <div class="content-wizard pa20">
        <div class="row">
          <div class="col-md-12 largeTitle">
            <i class="fa fa-map-marker"></i>
            Adresse du rendez-vous
            <hr>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>Veuillez saisir une adresse</label>
            </div>
          </div>
          <div class="col-md-6"
               :class="{ 'sk-loading': getAvailablePartnersIsLoading }"
          >
            <spinner-double-bounce :displayNone="!getAvailablePartnersIsLoading"/>
            <p class="centerText" v-if="getAvailablePartnersIsLoading">
              Recherche des partenaires disponibles sur la zone …
            </p>

            <gmap-autocomplete ref="gmapAddress"
                               class="form-control"
                               :componentRestrictions="{'country': ['fr']}"
                               v-show="!getAvailablePartnersIsLoading"
                               @place_changed="(p) => onPlaceChanged(p, 'vehicleInfos')"/>
          </div>
        </div>
        <div class="row mt20">
          <div class="col-md-12">
            <label>Cette adresse correspond:</label>
            <button
                v-for="option in addressOptions"
                :key="option.text"
                @click="updateAddressValue(option)"
                type="button"
                class="btn btn-w-m mt20 mr6"
                :class="[option.value === vehicleInfos.addressRadio ? 'btn-primary' : 'btn-secondary']"
            >
              {{ option.text }}
            </button>
          </div>
        </div>
        <div class="row pa10 mt20" v-if="getAvailablePartnersError">
          <p class="text-error">
            Désolé, un problème est survenu lors de la recherche des partenaires disponibles sur la zone. <br>
            Veuillez essayer à nouveau.
          </p>
        </div>

        <div>
          <div class="row mt20">
            <div class="col-md-12">
              <p class="text-error"
                 v-if="vehicleInfos.address !== '' &&
                                        vehicleInfos.availablePartners &&
                                        vehicleInfos.availablePartners.inspector === null"
              >
                *Aucun partenaire à moins de 30 minutes* <br>
                Malheureusement, CARIZY ne couvre pas encore votre zone géographique. Nous ne pouvons donc pas vous proposer un rendez-vous d'inspection.
              </p>
              <p class="text-success"
                 v-if="vehicleInfos.address !== '' &&
                                        vehicleInfos.availablePartners &&
                                        vehicleInfos.availablePartners.inspector"
              >
                L'inspection pourra se dérouler:
              </p>
              <p class="text-success"
                 v-if="vehicleInfos.address !== '' &&
                                        vehicleInfos.availablePartners &&
                                        vehicleInfos.availablePartners.inspector"
              >
                - A domicile
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div class="row">
      <div class="col-md-12 pa10">
        <div class="content-wizard pa20">
          <div class="row">
            <div class="col-md-12 largeTitle">
              <i class="fa fa-car"></i>
              Entretien et état du véhicule
              <hr>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>
                La dernière immatriculation du véhicule date-t-elle de plus de 6 mois (I.) ?
                <span v-tooltip.top-center="'Correspond à la nomenclature I. de la carte grise'">
                                    <i class="fa fa-info-circle"></i>
                                </span>
              </label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateLastImmatOlderThan6MonthsRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.lastImmatOlderThan6MonthsRadio ? (vehicleInfos.lastImmatOlderThan6MonthsRadio === 'yes' ? 'btn-primary' : 'btn-danger') : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.lastImmatOlderThan6MonthsRadio === 'no'">
            <div class="col-md-12">
              <p class="text-error">
                Désolé la dernière immatriculation du véhicule doit dater de moins de 6 mois
              </p>
            </div>
          </div>
          <div class="row mt20" v-if="dateIsInMoreThan4YearsOld">
            <div class="col-md-12">
              <label>Le dernier contrôle technique date-t-il de moins de deux ans ?</label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateTechnicalControl2YearsRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.technicalControl2YearsRadio ? (vehicleInfos.technicalControl2YearsRadio === 'yes' ? 'btn-primary' : 'btn-danger') : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="dateIsInMoreThan4YearsOld && vehicleInfos.technicalControl2YearsRadio === 'yes'">
            <div class="col-md-12">
              <label>a-t-il été fait il y a moins de 6 mois ?</label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateTechnicalControl6MonthsRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.technicalControl6MonthsRadio ? 'btn-primary' : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.technicalControl2YearsRadio === 'no'">
            <div class="col-md-12">
              <p class="text-error">
                Désolé le dernier contrôle technique doit dater de moins de 2 ans
              </p>
            </div>
          </div>
          <div class="row mt20">
            <div class="col-md-12">
              <label>La dernière révision date-t-elle de moins de 2 ans ou 20 000 km ?</label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateRevisionRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.revisionRadio ? 'btn-primary' : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20">
            <div class="col-md-12">
              <label>
                L’état du véhicule est-il conforme ?
                <span data-html="true"
                      data-trigger="hover"
                      data-toggle="popover"
                      data-placement="right"
                      data-container="body"
                      data-content="
                    Les éléments ci dessous correspondent à une non-conformité : <br><br>
                    <strong>Etat extérieur</strong> <br><br>
                    Bosses, malfaçon (mauvaise teinte…) OU tout enfoncement nécessitant un travail de carrosserie. <br><br>
                    Éraflures profondes - La peinture de fond est visible. La zone doit de nouveau être laquée. <br><br>
                    Endroit rouille - la rouille pénètre dans les soufflures de la peinture. Le métal devient alors rouillé. <br><br>
                    Pare-Brise - Impact présent dans le champ de vision ou accompagné d’une fissure (plus gros qu’une pièce de deux euros). <br><br>
                    Rétroviseurs, feux : Toute surface vitre cassée OU trous sur le feux causant un problème d'étanchéité.  <br><br>
                    <strong>Etat intérieur</strong> <br><br>
                    Intérieur dégradé avec des brûlures profondes et permanentes OU des déchirures importantes.   <br><br>
                    <strong>Etat mécanique</strong> <br><br>
                    Défauts électriques ou électroniques - Voyants rouge ou orange allumés sur le tableau de bord.">
                                    <i class="fa fa-info-circle"></i>
                                </span>
              </label>

              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateBodyRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.bodyRadio ? (vehicleInfos.bodyRadio === 'yes' ? 'btn-primary' : 'btn-danger') : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.bodyRadio === 'no'">
            <div class="col-md-12">
              <p class="text-error">
                L’état du véhicule doit être conforme pour pouvoir prendre un RDV d’inspection
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-12 pa10">
        <div class="content-wizard pa20">
          <div class="row">
            <div class="col-md-12 largeTitle">
              <i class="fa fa-book"></i>
              Etat administratif
              <hr>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label>
                Numéro de formule (facultatif)
                <span data-html="true"
                      data-trigger="hover"
                      data-toggle="popover"
                      data-placement="right"
                      data-container="body"
                      data-content="
                                Ce numéro nous permet de vérifier l’état administratif du véhicule. Il est situé sur la première page ou en bas à gauche du certificat d’immatriculation
                                <img style='max-width:95%;' src='https://www.entreprendre.fr/wp-content/uploads/visu_1467019823.jpg' />
                                "
                >
                                    <i class="fa fa-info-circle"></i>
                                </span>
              </label>
              <input name="vehicleInfos.formulaNumber"
                     type="text"
                     class="form-control maxWidth400px"
                     v-model="vehicleInfos.formulaNumber">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>Le véhicule est-il d’origine française ?</label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateFrenchRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.frenchRadio ? 'btn-primary' : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.frenchRadio === 'no'">
            <div class="col-md-12">
              <label>Le client possède-t-il la facture d’achat ?</label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateImportedInvoiceRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.importedInvoiceRadio ? (vehicleInfos.importedInvoiceRadio === 'yes' ? 'btn-primary' : 'btn-danger') : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.importedInvoiceRadio === 'no'">
            <div class="col-md-12">
              <p class="text-error">
                Désolé la facture d'achat est obligatoire pour un véhicule importé
              </p>
            </div>
          </div>

          <div class="row mt20">
            <div class="col-md-12">
              <label>
                Le véhicule est-il libre de tout contrat de location ?
                <span v-tooltip.top-center="'Un contrat de location correspond à un Leasing,  une Location longue durée, une Location avec option d’achat'">
                                    <i class="fa fa-info-circle"></i>
                                </span>
              </label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateFreeRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.freeRadio ? (vehicleInfos.freeRadio === 'yes' ? 'btn-primary' : 'btn-danger') : 'btn-secondary']"
              >
                {{ option.text }}

              </button>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.freeRadio === 'no'">
            <div class="col-md-12">
              <p class="text-error">
                Désolé, mais le véhicule doit être libre de tout contrat de location pour une vente entre particulier
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 pa10">
        <div class="content-wizard pa20">
          <div class="row">
            <div class="col-md-12 largeTitle">
              <i class="fa fa-exchange"></i>
              Projet d’achat
              <hr>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>Le client a-t-il un projet d’achat ?</label>
              <button
                  v-for="option in yesNoOptions"
                  :key="option.text"
                  @click="updateWishToBuyANewCarRadioValue(option)"
                  type="button"
                  class="btn btn-w-m mt20 mr6"
                  :class="[option.value === vehicleInfos.wishToBuyANewCarRadio ? 'btn-primary' : 'btn-secondary']"
              >
                {{ option.text }}
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.wishToBuyANewCarRadio === 'yes'">
            <div class="col-md-12">
              <div @click="onChangeNewVehicleCheckbox">
                <div class="carizyPretty pretty p-switch p-fill">
                  <input type="checkbox" v-model="vehicleInfos.newVehicleCheckbox"/>
                  <div class="state p-success">
                    <label>Un véhicule neuf</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt20" v-if="vehicleInfos.wishToBuyANewCarRadio === 'yes'">
            <div class="col-md-12">
              <div @click="onChangeSecondHandVehicleCheckbox">
                <div class="carizyPretty pretty p-switch p-fill">
                  <input type="checkbox" v-model="vehicleInfos.secondHandVehicleCheckbox"/>
                  <div class="state p-success">
                    <label>Un véhicule d’occasion</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 pa10">
        <div class="content-wizard pa20">
          <div class="row">
            <div class="col-md-12 largeTitle">
              <i class="fa fa-comment-o"></i>
              Commentaire
              <hr>
            </div>
          </div>
          <div class="row mt20">
            <div class="form-group col-md-12">
              <textarea v-model="vehicleInfos.comment" class="form-control" placeholder=""></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pa17">
      <button
          @click="goToPreviousStep"
          type="button"
          class="pull-left btn btn-w-m"
          :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
      >
        Précédent
      </button>
      <button
          @click="goToNextStep"
          type="button"
          class="btn btn-w-m pull-right"
          :disabled="disableGoToNextStep"
          :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
      >
        Suivant
      </button>
    </div>
  </div>
</template>


<script>
import gql from 'graphql-tag'
import { formatAddress, addressToString } from '../../../helpers/utils'
import SpinnerDoubleBounce from '@/components/spinners/SpinnerDoubleBounce'


export default {
  name: "Vehicle",

  components: {
    SpinnerDoubleBounce
  },

  props: {
    activeStep: {
      type: Number,
      required: true
    },
    entity: {
      type: String,
      required: true
    },
    vehicle: {
      type: Object
    },
    quotation: {
      type: Object,
    },
    vehicleInfosProp: {
      type: Object
    },
    userInfos: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    autoSave: null,
    addressOptions: [
      { text: "Au domicile du client", value: 1 },
      { text: "Au lieu de travail du client", value: 2 },
      { text: "Autre", value: 3 }
    ],
    yesNoOptions: [
      { text: "Oui", value: "yes" },
      { text: "Non", value: "no" },
    ],
    feuVertCenterOptions: [],
    vehicleInfos: {
      address: "",
      addressRadio: "",
      lastImmatOlderThan6MonthsRadio: "",
      technicalControl2YearsRadio: "",
      technicalControl6MonthsRadio: "",
      revisionRadio: "",
      bodyRadio: "",
      frenchRadio: "",
      importedInvoiceRadio: "",
      freeRadio: "",
      wishToBuyANewCarRadio: "",
      newVehicleCheckbox: false,
      secondHandVehicleCheckbox: false,
      availablePartners: null,
      comment: "",
      formulaNumber: "",
      selectedFeuVertCenter: null,
      coordinate: {
        latitude: null,
        longitude: null,
      }
    },
    getAvailablePartnersIsLoading: false,
    getAvailablePartnersError: false,
    getAllTheFeuvertPartnersIsLoading: false,
  }),

  computed: {
    dateIsInMoreThan4YearsOld () {
      if(this.vehicle && this.vehicle.dateMEC){
        let vehicleDateMEC = moment(this.vehicle.dateMEC, "DD/MM/YYYY");
        let date4YearsAgo = moment().subtract(4, 'years')
        return moment(date4YearsAgo).isAfter(vehicleDateMEC)
      }
      if(this.quotation && this.quotation.car){
        return this.quotation.car.over4years
      }
      return true
    },
    disableGoToNextStep () {
      if(this.vehicleInfos.lastImmatOlderThan6MonthsRadio === "no" || this.vehicleInfos.lastImmatOlderThan6MonthsRadio === ""){
        return true
      } else if (this.dateIsInMoreThan4YearsOld && (this.vehicleInfos.technicalControl2YearsRadio === "no" || this.vehicleInfos.technicalControl2YearsRadio === "")) {
        return true
      } else if (this.vehicleInfos.bodyRadio === "no" || this.vehicleInfos.bodyRadio === "") {
        return true
      } else if (this.vehicleInfos.freeRadio === "no" || this.vehicleInfos.freeRadio === "") {
        return true
      } else if (this.vehicleInfos.revisionRadio === "" || this.vehicleInfos.frenchRadio === "") {
        return true
      } else if (this.vehicleInfos.frenchRadio === "no" && (this.vehicleInfos.importedInvoiceRadio === "" || this.vehicleInfos.importedInvoiceRadio === "no")) {
        return true
      } else if (this.vehicleInfos.wishToBuyANewCarRadio === "yes" && this.vehicleInfos.newVehicleCheckbox === false && this.vehicleInfos.secondHandVehicleCheckbox === false) {
        return true
      } else if (this.vehicleInfos.addressRadio === "") {
        return true
      } else if (this.isAddressIncomplete(this.vehicleInfos.address)) {
        return true
      } else if (this.vehicleInfos.availablePartners && this.vehicleInfos.availablePartners.inspector === null) {
        return true
      } else if (this.userInfos && this.userInfos.expert && this.vehicleInfos.availablePartners) {
        if (this.vehicleInfos.availablePartners.inspector === null) {
          return true
        }
      } else if (this.getAvailablePartnersError) {
        return true
      } else {
        return false
      }
    },
  },

  beforeDestroy () {
    clearInterval(this.autoSave)
  },

  created () {
    this.autoSaveData()
  },

  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    autoSaveData () {
      this.autoSave = setInterval(() => {
        this.$emit('pass-vehicle-infos-data', this.vehicleInfos)
      }, 1000)
    },
    goToPreviousStep () {
      clearInterval(this.autoSave)
      this.$emit('go-to-previous-step', 2)
    },
    goToNextStep () {
      clearInterval(this.autoSave)
      this.$emit('pass-vehicle-infos-data', this.vehicleInfos)
      this.$emit('go-to-next-step', 4)
    },
    onChangeTechnicalControl2YearsRadio () {
      this.vehicleInfos.technicalControl6MonthsRadio = ""
    },
    onChangeFrenchRadio () {
      this.vehicleInfos.importedInvoiceRadio = ""
    },
    onChangeWishToBuyANewCarRadio () {
      this.vehicleInfos.newVehicleCheckbox = false
      this.vehicleInfos.secondHandVehicleCheckbox = false
    },
    onPlaceChanged (place, type) {
      this[type].address = formatAddress(place)
      this.vehicleInfos.coordinate.latitude = place.geometry.location.lat();
      this.vehicleInfos.coordinate.longitude = place.geometry.location.lng();

      if (this.isAddressIncomplete(this[type].address)) {
        this.showBanner('danger', 'Veuillez saisir une adresse complète pour continuer')
      } else {
        this.getAvailablePartners()
      }
    },
    isAddressIncomplete (address) {
      return address.address === '' || address.zipCode === '' || address.city === ''
    },
    onChangefeuVertCenterOptions () {
      this.vehicleInfos.address = this.vehicleInfos.selectedFeuVertCenter.address
      this.vehicleInfos.addressRadio = 3
      this.getAvailablePartners()
    },
    async getAvailablePartners () {
      this.getAvailablePartnersIsLoading = true
      this.getAvailablePartnersError = false

      this.$apollo.query({
        query: gql`
                      query {
                       availablePartnersWithoutValuation(
                            realm: "${this.entity}",
                            address: "${this.vehicleInfos.address.address}",
                            zipcode: "${this.vehicleInfos.address.zipCode}",
                            city: "${this.vehicleInfos.address.city}"
                       ) {
                            inspector {
                                id
                                name
                                address
                                accessInfo
                                zipcode
                                city
                                email
                                phoneNumber
                                cellNumber
                                isActive
                                maxMinutes
                                calendar
                            }

                       }
                      }`,
        fetchPolicy: 'no-cache'
      }).then(response => {
        this.vehicleInfos.availablePartners = response.data.availablePartnersWithoutValuation
        this.getAvailablePartnersIsLoading = false
      }, () => {
        this.showBanner('danger', 'Désolé, un problème est survenu lors de la recherche des partenaires disponibles sur la zone')
        this.vehicleInfos.availablePartners = []
        this.getAvailablePartnersIsLoading = false
        this.getAvailablePartnersError = true
      })
    },
    updateAddressValue (option) {
      this.vehicleInfos.addressRadio = option.value
    },
    updateLastImmatOlderThan6MonthsRadioValue (option) {
      this.vehicleInfos.lastImmatOlderThan6MonthsRadio = option.value
    },
    updateTechnicalControl2YearsRadioValue (option) {
      this.vehicleInfos.technicalControl2YearsRadio = option.value
      this.onChangeTechnicalControl2YearsRadio()
    },
    updateTechnicalControl6MonthsRadioValue (option) {
      this.vehicleInfos.technicalControl6MonthsRadio = option.value
    },
    updateRevisionRadioValue (option) {
      this.vehicleInfos.revisionRadio = option.value
    },
    updateBodyRadioValue (option) {
      this.vehicleInfos.bodyRadio = option.value
    },
    updateFrenchRadioValue (option) {
      this.vehicleInfos.frenchRadio = option.value
      this.onChangeFrenchRadio()
    },
    updateImportedInvoiceRadioValue (option) {
      this.vehicleInfos.importedInvoiceRadio = option.value
    },
    updateFreeRadioValue (option) {
      this.vehicleInfos.freeRadio = option.value
    },
    updateWishToBuyANewCarRadioValue (option) {
      this.vehicleInfos.wishToBuyANewCarRadio = option.value
      this.onChangeWishToBuyANewCarRadio()
    },
    onChangeNewVehicleCheckbox () {
      this.vehicleInfos.newVehicleCheckbox = !this.vehicleInfos.newVehicleCheckbox
    },
    onChangeSecondHandVehicleCheckbox () {
      this.vehicleInfos.secondHandVehicleCheckbox = !this.vehicleInfos.secondHandVehicleCheckbox
    }
  },

  mounted () {
    this.scrollToTop()
    if(this.vehicleInfosProp){
      this.vehicleInfos = this.vehicleInfosProp
      if(this.vehicleInfosProp.address) {
        this.$refs.gmapAddress.$el.value = addressToString(this.vehicleInfosProp.address)
      }
    }
    $(document).trigger('vue-loaded')
  },
}
</script>

<style scoped>

</style>